import { post } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_USER_EVENTS } from "@src/appV2/lib/analytics";
import { useMutation } from "@tanstack/react-query";
import { z } from "zod";

import { focusModeViolationRequestSchema, type FocusModeViolationRequest } from "./types";

interface ReportFocusModeViolationParams extends FocusModeViolationRequest {
  shiftId: string;
}

export function useReportFocusModeViolation() {
  return useMutation({
    mutationFn: async ({ shiftId, ...data }: ReportFocusModeViolationParams) => {
      return post({
        url: `${environmentConfig.REACT_APP_BASE_API_URL}/shifts/${shiftId}/focus-mode/violation`,
        data,
        requestSchema: focusModeViolationRequestSchema,
        responseSchema: z.object({}),
      });
    },
    retry: 3,
    meta: {
      logErrorMessage: APP_V2_USER_EVENTS.FOCUS_MODE_VIOLATION_DETECTED,
    },
  });
}
